'use client';

import Loading from '@/app/components/design-system/Loading';

const LoadingFullScreen = () => {
	return (
		<div className="flex h-screen w-full items-center justify-center">
			<Loading />
		</div>
	);
};

export default LoadingFullScreen;
